<template>
  <div class="your-opportunity">
    <div class="margin-general">
      <div class="text-content">
        <h2>{{ $t("accounts.yourOpp.title") }}</h2>
        <!-- <p class="text-1 body-4">{{ $t("accounts.yourOpp.desc") }}</p> -->
      </div>
      <div class="card-desc">
        <ul class="card">
          <li v-for="row in filteredCardOpportunity" :key="row.item || row.contents[0].text" class="body-4">
            <template v-if="row.contents">
              <!-- Handling combined items -->
              <span v-for="content in row.contents" :key="content.text">
                <template v-if="content.type === 'text'">{{ $t(content.text) }}</template>
                <template v-if="content.type === 'link'">
                  <a :href="content.url" target="_blank" rel="noopener noreferrer">{{ $t(content.text) }}</a>
                </template>
              </span>
            </template>
            <template v-else>
              {{ $t(row.item) }}
            </template>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();

const cardOpportunity = [
  { item: "accounts.yourOpp.item1", alwaysVisible: true },
  { item: "accounts.yourOpp.item2", alwaysVisible: true },
  { item: "accounts.yourOpp.item3", alwaysVisible: true },
];

const filteredCardOpportunity = computed(() => {
  return cardOpportunity.filter(item => {
    if (item.contents) {
      // Filtrar los contenidos individuales dentro de los ítems combinados
      item.contents = item.contents.filter(content => content.alwaysVisible || (content.visibleOnlyIn && content.visibleOnlyIn.includes(locale.value)));
      return item.contents.length > 0;
    }
    return item.alwaysVisible || !item.hiddenInLocales?.includes(locale.value);
  });
});
</script>

